import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { If } from 'aa_common/front-end/components'
import { Typography } from 'antd'

import { NoticeWrapper } from '../styles'

type AINoticeProps = {
  title?: string
  text: string
  className?: string
  icon: IconProp
}

export const AINotice = ({ className, icon, title, text }: AINoticeProps) => {
  return (
    <NoticeWrapper className={className}>
      <FontAwesomeIcon icon={icon} />
      <div>
        <If condition={title}>
          <Typography.Title level={5}>{title}</Typography.Title>
        </If>
        <Typography.Text>{text}</Typography.Text>
      </div>
    </NoticeWrapper>
  )
}
